module.exports = __webpack_public_path__ + "img/next_arrow.079f0ea5.svg";